import React from 'react'
import { useParams } from 'react-router'
import { useState,useEffect,useRef } from 'react'
import Top from '../../components/public/pages/user/top'
import Listings from '../../components/public/pages/user/listings'
import ProfileButton from '../../components/forms/profileButton'
import '../../css/public/user.css'
import { Link } from 'react-router-dom'
import ApiUrl from '../../configTools/apiUrl'
import DocumentMeta from 'react-document-meta'

const User = () => {
  const UserInfo = JSON.parse(localStorage.getItem("user-info"));
  const {username} = useParams();
  const popupBoxFollower = useRef(null);
  function FollowerOpen(){
    popupBoxFollower.current.className = 'user_profile_follow_wrapper active';
  }
  function FollowerClose(){
    popupBoxFollower.current.className = 'user_profile_follow_wrapper';
  }
  const popupBoxFollowing = useRef(null);
  function FollowingOpen(){
    popupBoxFollowing.current.className = 'user_profile_follow_wrapper active';
  }
  function FollowingClose(){
    popupBoxFollowing.current.className = 'user_profile_follow_wrapper';
  }
  const [followers,setFollowers] = useState([]);
  const [following,setFollowing] = useState([]);
  const [userDetails,setUserDetails] = useState({
    id : 0,
    activetoday : true,
    username : "",
    discription : "",
    firstname : "",
    lastname : "",
    followers : 0,
    following : 0,
    averagestars : 3,
    reviewcount : 100,
    image : "",
    followingthis : false,
    soldcount : 0,
    postcount : 0,
    role: ''
  });
  const metaIndividual = {
    title: username+' is now at KAAY - Follow '+username+'/ to keep Updated',
    description: username+" is now at KAAY Pakistan’s 1st ever social commerce platform or the social media for shopping. At KAAY you can chat with both sellers & buyers and even follow them to keep yourself updated with their latest posts. Join now & become a part of KAAY’s community.",
    canonical: window.location.href
    /*,
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'react,meta,document,html,tags'
        }
    }*/
  }
  const metaBusinees = {
    title: 'Shop from '+username+' online at KAAY',
    description: `${username} is now available online at KAAY. Shop the elegant and trendy designs from ${username} with the lowest available shipping charges in Pakistan. in case of any query or feedback you can chat directly on the platform, or follow them on kaay to keep yourself updated with their latest products and work.`,
    canonical: window.location.href
    /*,
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'react,meta,document,html,tags'
        }
    }*/
  }

  function profile_refresh(){
    let usercall = 0;
    if(UserInfo){
        usercall = UserInfo.id
    }
    fetch(ApiUrl.API_URL_Profile+"/"+usercall+"/"+username)
    .then(res=>res.json())
    .then(data =>{
      if(data.success){
        setUserDetails(data.responce);
      }
    });
  }
    const change_follow = (fuserid)=>{
      fetch(ApiUrl.API_URL_Follower, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+UserInfo.token
        },
        body: JSON.stringify({
            followtoid : fuserid
        })
      })
      .then(res=>res.json())
      .then(data =>{
        userFollowingRefresh();
      });
    }
    const userFollowingRefresh = ()=>{
      fetch(ApiUrl.API_URL_FollowList+'/'+userDetails.id+'/0', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+UserInfo.token
        }
      })
      .then(res=>res.json())
      .then(data =>{
        setFollowers(data.responce);
      });
      fetch(ApiUrl.API_URL_FollowList+'/'+userDetails.id+'/1', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+UserInfo.token
        }
      })
      .then(res=>res.json())
      .then(data =>{
        setFollowing(data.responce);
      });
    }
  useEffect(() => {
    let usercall = 0;
    if(UserInfo){
        usercall = UserInfo.id
    }
    fetch(ApiUrl.API_URL_Profile+"/"+usercall+"/"+username)
    .then(res=>res.json())
    .then(data =>{
      if(data.success){
        setUserDetails(data.responce);
      }
    });
  },[username])
  useEffect(()=>{
    if(UserInfo){
      fetch(ApiUrl.API_URL_FollowList+'/'+userDetails.id+'/0', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+UserInfo.token
        }
      })
      .then(res=>res.json())
      .then(data =>{
        console.log(data)
        setFollowers(data.responce);
      });
      fetch(ApiUrl.API_URL_FollowList+'/'+userDetails.id+'/1', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+UserInfo.token
        }
      })
      .then(res=>res.json())
      .then(data =>{
        console.log(data)
        setFollowing(data.responce);
      });
    }
  },[userDetails])
  var meta = userDetails.role === 'individual'? metaIndividual : metaBusinees;
  return (
    <>
      <DocumentMeta {...meta} />
      <div className='user_profile_wrapper'>
        <Top Values = {userDetails} Refresh={profile_refresh} User={UserInfo} FollowerOpen={FollowerOpen} FollowingOpen={FollowingOpen}/>
        <Listings username = {username}/>
      </div>
      <div className='user_profile_follow_wrapper' ref={popupBoxFollower}>
        <div className='user_profile_follow_container'>
          <div className='user_profile_follow_close'>
            <button onClick={FollowerClose}>X</button>
          </div>
          {followers.map((item,index)=>{
            return(
                <div className='user_profile_follow_item' key={index}>
                  <div className='user_profile_follow_item_image'>
                    <label style={{cursor:"pointer"}}>
                        <div style={{
                            width: "100%",
                            paddingTop: "80%",
                            borderRadius: "10px",
                            position: "relative",
                            backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.image})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center'
                        }}>
                        </div>
                    </label>
                  </div>
                  <div className='user_profile_follow_item_userdetails'>
                  <Link to={'/user/'+item.username}>
                    <h4>{item.name}</h4>
                  </Link>
                  <Link to={'/user/'+item.username}>
                    <h5>{item.username}</h5>
                  </Link>
                  </div>
                  <div className='user_profile_follow_item_follow'>
                    {UserInfo.username !== item.username &&
                      <ProfileButton Value={item.isFollowing? "Unfollow": "Follow"} Action={()=>{change_follow(item.id)}} style={{cursor:"pointer"}}/>
                    }
                  </div>
                </div>
            )
          })
          }
        </div>
      </div>
      <div className='user_profile_follow_wrapper' ref={popupBoxFollowing}>
        <div className='user_profile_follow_container'>
          <div className='user_profile_follow_close'>
            <button onClick={FollowingClose}>X</button>
          </div>
          {following.map((item,index)=>{
            return(
                <div className='user_profile_follow_item' key={index}>
                  <div className='user_profile_follow_item_image'>
                    <label style={{cursor:"pointer"}}>
                        <div style={{
                            width: "100%",
                            paddingTop: "80%",
                            borderRadius: "10px",
                            position: "relative",
                            backgroundImage:`url(${ApiUrl.API_URL_Image_Thumbnail+item.image})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center'
                        }}>
                        </div>
                    </label>
                  </div>
                  <div className='user_profile_follow_item_userdetails'>
                  <Link to={'/user/'+item.username}>
                    <h4>{item.name}</h4>
                  </Link>
                  <Link to={'/user/'+item.username}>
                    <h5>{item.username}</h5>
                  </Link>
                  </div>
                  <div className='user_profile_follow_item_follow'>
                    {UserInfo.username !== item.username &&
                      <ProfileButton Value={item.isFollowing? "Unfollow": "Follow"} Action={()=>{change_follow(item.id)}} style={{cursor:"pointer"}}/>
                    }
                  </div>
                </div>
            )
          })
          }
        </div>
      </div>
    </>
  )
}

export default User
